import React, { useEffect, useState } from 'react'
import { SocketState } from '../../../context/SocketProvider'
import { useDispatch, useSelector } from 'react-redux'
import { SET_MAIN_LOADER } from '../../../redux/loaderSlice'
import { SET_TITLI_ADVANCE_DRAW_SELECT_TIME, SelectTitliAdvanceDrawSelectTime, SelectTitliTimeSlot } from '../../../redux/titli-slice/gameInfoTitliSlice'
import { useNavigate } from 'react-router-dom'
import { setAdvanceTimeSlotCount } from '../../../redux/seriesSlice'
import Checkbox4 from '../../../2d-game/componenent/checkbox/Checkbox4'
import ModalContainer from '../../../2d-game/modals/ModalContainer'

function AdvanceDrawTitliModal() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  let { socket } = SocketState()
  let TimeSlot = useSelector(SelectTitliTimeSlot)
  let AdvanceDrawSelectTime = useSelector(SelectTitliAdvanceDrawSelectTime)

  const [timeSlot, setTimeSlot] = useState([]);
  const [selectCount, setSelectCount] = useState(null);
  const [selectAllFlag, setSelectAllFlag] = useState(false)


  useEffect(() => {
    dispatch(SET_MAIN_LOADER(true))
    socket.emit('req', { "en": "LUCKY_SORAT_ADVANCE_DRAW_TIME_SLOT", "data": {} })
  }, [])


  // set flag
  useEffect(() => {
    if (TimeSlot.length) {
      let timeArray = JSON.parse(JSON.stringify(TimeSlot)).map((time) => {

        if (time.status === 'completed') {
          time.disable = true;
        } else {
          time.disable = false
        }
        time.select = AdvanceDrawSelectTime.includes(time.time) ? true : false;
        return time;
      });
      setTimeSlot(timeArray);
    }
  }, [TimeSlot]);


  // select count
  useEffect(() => {
    if (timeSlot.length) {
      let copytimeArray = [...timeSlot];
      for (let index = 0; index < copytimeArray.length; index++) {
        copytimeArray[index].select = false;
      }
      if (selectCount) {
        let findIndex = copytimeArray.findIndex((time) => !time.disable);
        let count = Number(findIndex) + Number(selectCount);
        for (let index = findIndex; index < count; index++) {
          if (copytimeArray[index]) {
            copytimeArray[index].select = true;
          }
        }
      }
      setTimeSlot(copytimeArray);
    }
  }, [selectCount]);


  //   selectAll

  // select count
  useEffect(() => {
    if (timeSlot.length) {
      let copytimeArray = [...timeSlot];
      for (let index = 0; index < copytimeArray.length; index++) {
        copytimeArray[index].select = false;
      }
      if (selectAllFlag) {
        let findIndex = copytimeArray.findIndex((time) => !time.disable);
        let count = Number(findIndex) + Number(copytimeArray.length);
        for (let index = findIndex; index < count; index++) {
          if (copytimeArray[index]) {
            copytimeArray[index].select = true;
          }
        }
      }
      setSelectCount(null)
      setTimeSlot(copytimeArray);
    }
  }, [selectAllFlag]);

  // set select Count
  let onSubmit = () => {
    if (timeSlot.length) {
      let filter = []
      timeSlot.forEach(time => { if (time.select) filter.push(time.time) })

      dispatch(SET_TITLI_ADVANCE_DRAW_SELECT_TIME(filter))
      dispatch(setAdvanceTimeSlotCount(filter?.length))
      navigate('/titli')
    }
  }

  return (
    <ModalContainer title={'Advance Draw'} navigation={'/titli'}>
      <div className='flex w-[90%] mx-auto flex-wrap h-[calc(100vh-40vh)] overflow-y-auto'>
        {timeSlot?.map((time, index) => (
          <div
            key={index}
            className="
              w-1/6 px-1 py-1.5
              sm:w-1/4      /* 4 columns on small screens */
              xs:w-1/3      /* 3 columns on extra small screens */
              max-[480px]:w-1/2   /* 2 columns on very small mobile */
            "
          >
            <div
              className={`border-2 py-3 rounded-lg border-gray-300 flex items-center justify-center gap-2 cursor-pointer 
                ${time.disable ? 'bg-gray-400' : 'bg-white'}`}
            >
              <Checkbox4
                disabled={time.disable}
                checked={time.select}
                onChange={(e) => {
                  const copyTimeSlot = [...timeSlot];
                  copyTimeSlot[index].select = e.target.checked;
                  setTimeSlot([...copyTimeSlot]);
                }}
              />
              <p className="font-semibold text-[17px]">{time.time}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="absolute bottom-0 left-0 w-full pb-4 px-2 bg-white border-t border-gray-200">
        {/* Top Section — No of Draws + Select All */}
        <div className="flex flex-wrap justify-center items-center mb-4 gap-3 text-center sm:text-left">
          <p className="font-semibold text-[16px] sm:text-[18px] mr-2 sm:mr-4">No of Draws</p>

          <input
            className={`shadow appearance-none border border-black rounded w-[70px] sm:w-[80px] py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-center ${selectAllFlag ? 'cursor-not-allowed opacity-70' : 'cursor-text'
              }`}
            type="text"
            value={selectCount ? selectCount : ''}
            onChange={(e) => setSelectCount(e.target.value)}
            disabled={!!selectAllFlag}
          />

          <div className="flex items-center gap-2 mt-2 sm:mt-0">
            <Checkbox4
              checked={selectAllFlag}
              onChange={(e) => setSelectAllFlag(e.target.checked)}
            />
            <p className="font-semibold text-[15px] sm:text-[17px]">Select All</p>
          </div>
        </div>

        {/* Bottom Section — Buttons */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 w-full px-2 sm:px-0">
          {/* CLEAR button */}
          <button
            className="w-[48%] sm:w-1/5 rounded-lg py-3 bg-[#374566] text-white font-semibold text-[15px] sm:text-[16px] hover:opacity-90 transition"
            onClick={() => {
              const copytimeArray = [...timeSlot];
              copytimeArray.forEach((time) => (time.select = false));
              setTimeSlot(copytimeArray);
              setSelectCount(null);
              dispatch(SET_TITLI_ADVANCE_DRAW_SELECT_TIME([]));
            }}
          >
            CLEAR
          </button>

          {/* CANCEL button */}
          <button
            className="w-[48%] sm:w-1/5 rounded-lg py-3 bg-[#374566] text-white font-semibold text-[15px] sm:text-[16px] hover:opacity-90 transition"
            onClick={() => navigate('/2d')}
          >
            CANCEL
          </button>

          {/* OK button */}
          <button
            className="w-full sm:w-1/5 rounded-lg py-3 bg-[#F8F7A3] text-black font-semibold text-[15px] sm:text-[16px] hover:opacity-90 transition"
            onClick={onSubmit}
          >
            OK
          </button>
        </div>

      </div>

    </ModalContainer>
  )
}

export default AdvanceDrawTitliModal